export default "type ResetPasswordForm @form {\n  \"New password\"\n  newPassword: String! @input(type: \"password\")\n}\n";